import { create } from 'zustand';
import * as types from '../../_types/types.type';

interface OrgData {
  id: string;
  name: string;
  configParms: {
    features?: {
      route?: {
        mapboxKey?: string;
        enabled?: boolean;
        [key: string]: any;
      };
      [key: string]: any;
    };
    [key: string]: any;
  };
  docuSealAccess?: string; // Add docuSealAccess field
  [key: string]: any;
}

interface OrgStore {
  circleLevels: types.CircleLevelPartial[];
  setCircleLevels: (circleLevels: types.CircleLevelPartial[]) => void;
  KPIs: types.KPIRulePartial[];
  setKPIs: (KPIs: types.KPIRulePartial[]) => void;
  categories: types.StageCategoryPartial[];
  setCategories: (categories: types.StageCategoryPartial[]) => void;
  stageDispositions: types.StageDispositionPartial[];
  setStageDispositions: (
    stageDispositions: types.StageDispositionPartial[]
  ) => void;
  orgData: OrgData | null;
  setOrgData: (orgData: OrgData | null) => void;
  resetStore: () => void;
}

const useOrgStore = create<OrgStore>((set) => ({
  circleLevels: [],
  setCircleLevels: (circleLevels) => set({ circleLevels }),
  KPIs: [],
  setKPIs: (KPIs) => set({ KPIs }),
  stageDispositions: [],
  setStageDispositions: (stageDispositions) => set({ stageDispositions }),
  categories: [],
  setCategories: (categories) => set({ categories }),
  orgData: null,
  setOrgData: (orgData) => set({ orgData }),
  resetStore: () =>
    set({
      circleLevels: [],
      KPIs: [],
      categories: [],
      stageDispositions: [],
      orgData: null,
    }),
}));

export default useOrgStore;
